import React from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Oval } from "react-loader-spinner";
import Modal from "components/modal";
import LabelForm from "pages/signup/form/labelForm";

function PoRespondModal({
  title = "",
  isOpen,
  onClose = () => {},
  onSubmit = () => {},
  isLoading = false,
  acceptance = false,
  assigneeId = "",
}) {
  const [t] = useTranslation();

  return (
    <Modal isOpen={isOpen}>
      <div className="flex p-[32px] flex-col  gap-[36px] w-[80%]  max-w-[954px] max-h-[80%] overflow-auto bg-white rounded-[18px] relative">
        <div
          className="grid overflow-auto  h-full pb-[20px]"
          style={{ maxHeight: `calc(100% - 110px)` }}
        >
          <div className="text-base-black font-bold text-[30px] not-italic">
            {title}
          </div>

          <LabelForm
            label={t("confirmMessage", {
              acceptance: acceptance ? "accept" : "reject",
            })}
            labelClassName={`${
              acceptance ? "text-primary" : "text-red"
            } text-primary font-bold text-[20px] md-max:text-[16px] not-italic my-auto mb-[-10px]`}
          />
        </div>
        <div className="flex justify-end gap-[12px] self-stretch   h-[110px] items-center bg-white w-full border-t-[1px] border-solid border-default-color">
          <button
            type="button"
            onClick={onClose}
            disabled={isLoading}
            className="cursor-pointer flex py-[14px] px-[16px] gap-[8px] justify-center items-center rounded-[6px] border-[1px] border-solid border-default-color bg-white h-[46px]"
          >
            <div className="text-base-black font-bold text-[16px] not-italic">
              {t("Cancel")}
            </div>
          </button>
          <button
            type="button"
            onClick={() => onSubmit(assigneeId, acceptance)}
            disabled={isLoading}
            className="cursor-pointer flex py-[14px] px-[16px] gap-[8px] justify-center items-center rounded-[6px] border-[1px] border-solid border-primary bg-primary h-[46px]"
          >
            <Oval
              height={30}
              width={30}
              color="#FFF"
              visible={isLoading}
              ariaLabel="oval-loading"
              secondaryColor="#FFF"
              strokeWidth={5}
              strokeWidthSecondary={3}
            />
            <div className="text-white font-bold text-[16px] not-italic">
              {t("Confirm")}
            </div>
          </button>
        </div>
      </div>
    </Modal>
  );
}

PoRespondModal.propTypes = {
  title: PropTypes.string,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  isLoading: PropTypes.bool,
  acceptance: PropTypes.bool,
  assigneeId: PropTypes.string,
};

export default PoRespondModal;

